import { useField, useFormikContext } from 'formik'
import { BrandKitWidgetSelect } from './BrandKitWidgetSelect'

export const BrandKitWidgetInput = () => {
  const [brandKitIdField, ,] = useField('brand_kit_id')
  const { setFieldValue } = useFormikContext<{ [key: string]: any }>()

  const setBrandKitId = (brandKitId: number | undefined) => {
    setFieldValue('brand_kit_id', brandKitId)
  }

  return (
    <BrandKitWidgetSelect
      onBrandKitChange={(id?: number) => {
        setBrandKitId(id)
      }}
      selectedBrandKit={brandKitIdField.value}
    />
  )
}
